import { createStyles, makeStyles } from '@material-ui/core';
import { FONT_PRIMARY_COLOR } from 'src/style/variable';

const spaceBottomStyle = {
  marginBottom: '0.5rem'
};

export const useStyles = makeStyles(() =>
  createStyles({
    TextareaAutosize: {
      color: FONT_PRIMARY_COLOR,
      opacity: '1'
    },
    marginBottom: {
      ...spaceBottomStyle
    },
    stopTimeInputWrapper: {
      display: 'flex',
      gap: '0.5rem'
    },
    minuteIconWrapper: {
      marginBottom: '0.5em'
    },
    minuteIcon: {
      paddingBlock: '0rem',
      height: '2.3rem',
      borderRadius: '4px',
      border: '1px solid rgba(0, 0, 0, 0.26)'
    },
    addWorkLogTimeDialogActions: {
      display: 'flex'
    },
    or: {
      fontSize: '1.5rem',
      color: 'orange',
      textAlign: 'center'
    },
    gridPadding: {
      paddingBottom: 0
    },
    formControl: {
      padding: 0,
      margin: 0
    },
    notesWrapper: {
      marginTop: '0.8rem'
    },
    fieldWrapper: {
      // border: '1px solid #ced4da', // Border style
      // borderRadius: '4px', // Border radius
      // padding: '8px', // Padding
    },
    datePickerValue: {
      padding: '0',
      margin: '0',
      '&.MuiInputBase-root': {
        borderBottom: 0
      }
  }
  })
);
